import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

/**
 * The project's bank folders (`GET /project-bank/:projectId/folders`).
 *
 * `galleryView` says the caller can show a gallery-only user their part of
 * the bank (utils/bankAccess): the API then answers such a user with the
 * root and the images folder's subtree. Without it they get the 403 the
 * endpoint always gave, which is what the move and duplicate dialogs read as
 * "no permission" for a target project.
 * @param {string} projectId
 * @param {{galleryView?: boolean}} [options]
 */
export const getProjectFolders = async (projectId, { galleryView } = {}) => {
  const apiPath = `project-bank/${projectId}/folders${
    galleryView ? '?galleryView=1' : ''
  }`;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
    validateStatus: () => true,
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
